<template>
    <div class="tchat" :class="hidden ? 'tchat-small' : ''">
        <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center px-3 py-1 cursor-pointer" :class="notify ? 'blink' : ''" @click="toggleChat">
                <h5 class="mb-0">
                    <span class="bg-warning rounded px-1 py-0 my-0 mr-1 h6 new-messages" v-if="notify">
                        <i class="fad fa-bell fa-shake"></i>
                    </span>
                    <span class="my-0 mr-1 h6" v-else>
                        <i class="fad fa-messages"></i>
                    </span>
                    Tchat interne
                </h5>
                <span class="d-flex flex-row align-items-center">
                    <i class="fas fa-arrow-up text-muted fa-xs" v-if="hidden"></i>
                    <i class="fas fa-minus text-muted fa-xs" v-else></i>
                </span>
            </div>
            <div class="card-body ps px-2 py-1" :class="hidden ? 'd-none' : ''" id="tchat-messages">
                <div v-if="!enabled" class="alert alert-info">
                    Le tchat est désactivé
                </div>
                <div class="lcdd-tchat-errors small">
                    <errors-zone :errors="errors" />
                </div>
                <div class="d-flex flex-row mb-2" v-for="message in messages" :key="message.id">
                    <div class="my-1">
                        <div class="position-relative avatar">
                            <span class="avatar-picto position-absolute small badge badge-dark rounded-circle" v-if="message.from == 'slack'" title="Message envoyé depuis Slack">
                                <i class="fab fa-slack"></i>
                            </span>
                            <img :src="message.avatar" class="rounded border border-lightgray" />
                        </div>
                    </div>
                    <div class="flex-grow-1 ml-2">
                        <div class="d-flex justify-content-between">
                            <span class="small">
                                {{ message.username }}
                            </span>
                            <span class="small text-muted" :title="global.moment.unix(message.ts).format('dddd Do MMMM YYYY HH:mm')">
                                <dynamic-from-now :value="global.moment.unix(message.ts).toISOString()" />
                            </span>
                        </div>
                        <div class="d-flex flex-row justify-content-start">
                            <span class="px-2 py-1 rounded text-break overflow-hidden bg-light lcdd-tchat-message" v-html="message.text"></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer p-1" :class="hidden ? 'd-none' : ''">
                <div class="lcdd-tchat-errors small">
                    <errors-zone :errors="errorsSending" />
                </div>
                <div class="d-flex text-muted justify-content-start align-items-center">
                    <div class="input-group input-group-sm mb-0">
                        <input type="text" class="form-control" :disabled="sending || !enabled" placeholder="Message" aria-describedby="button-addon2" v-model="message" />
                        <div class="input-group-append">
                            <button class="btn btn-primary" :disabled="sending || !enabled" type="button" id="button-addon2" @click="sendMessage">Envoyer</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ErrorsZone from "./ErrorsZone";
import {useGetLoader} from "./compositions/axios/loadingRequest";
import {usePostRequest} from "./compositions/axios/postRequest";

export default {
    name: "Tchat",

    components: {
        ErrorsZone,
    },

    props: {
        tchatAction: {
            type: String,
            required: false,
        },
    },

    setup() {
        const { loading: loading, loaded: loaded, errors: errors, load: load } = useGetLoader();

        const { loading: sending, loaded: sent, errors: errorsSending, post: doPost } = usePostRequest();

        return {
            loading,
            loaded,
            errors,
            load,

            sending,
            sent,
            errorsSending,
            doPost,
        };
    },

    data() {
        return {
            messages: [],
            message: "",
            hidden: true,
            notify: false,
            enabled: false,
        };
    },

    created() {
        Echo.private(`employees`).listen("EmployeeMessageEvent", (e) => {
            this.loadStateFromServer();
        });
    },

    async mounted() {
        await this.loadStateFromServer();
    },

    watch: {
        messages: function () {
            this.$nextTick(function () {
                var self = this;
                setTimeout(function () {
                    self.scrollToDown();
                }, 100);
                this.scrollToDown();
            });
        },
    },

    methods: {
        loadStateFromServer: async function (hidden) {
            let params = [];
            if(typeof hidden !== "undefined") {
                params.push('hidden='+hidden);
            }
            let url = this.tchatAction+'?'+params.join('&');
            let response = await this.load(url);
            this.messages = _.reverse(response.messages);
            this.notify = false;
            for(let message of this.messages) {
                if(message.read === false) {
                    this.notify = true;
                }
            }
            this.hidden = response.hidden;
            this.enabled = response.enabled;
        },

        sendMessage: async function () {
            if (this.message.length > 0) {
                const data = await this.doPost(this.tchatAction, {
                    message: this.message,
                });
                if (data && data.success) {
                    this.message = "";
                }
            }
        },

        scrollToDown: function () {
            let container = this.$el.querySelector("#tchat-messages");
            container.scrollTop = container.scrollHeight;
        },

        toggleChat: function () {
            this.hidden = !this.hidden;
            if(this.hidden) {
                this.notify = false;
            }
            this.scrollToDown();
            this.loadStateFromServer(this.hidden);
        },
    },
};
</script>

<style scoped lang="scss">
.tchat {
    position: fixed;
    right: 0;
    bottom: 0;
    z-index: 9999;
    padding: 5px;
    width: 400px;
}
.tchat-small {
    width: 200px;
}
.card-header {
    border-top: 4px solid #ffa900;
}

.blink.card-header {
    animation: blinkingHeader 0.5s infinite;
}
@keyframes blinkingHeader {
    0% {
        border-top-color: #ffa900;
    }
    50% {
        border-top-color: #ef0a1a;
    }
    100% {
        border-top-color: #ffa900;
    }
}

.card-body {
    position: relative;
    height: 400px;
}
.lcdd-tchat-message {
    font-family: "Open Sans", sans-serif;
}
.ps {
    overflow-x: hidden;
    overflow-y: scroll;
    overflow-anchor: none;
    touch-action: auto;
}
.bg-brown {
    background-color: #eeddd0 !important;
}
.border-lightgray {
    border-color: #cbcbcb !important;
}
.avatar, .avatar img {
    width: 40px;
    height: 40px;
}
.avatar-picto {
    bottom: -5px;
    right: -5px;
}
.lcdd-tchat-errors .alert {
    padding: 0.3rem 0.6rem;
    margin-bottom: 0.3rem;
}
</style>

<style lang="scss">
// not scoped

.lcdd-tchat-message .img-container {
    height: 150px;
}
.lcdd-tchat-message pre {
    margin-bottom: 0;
}
.lcdd-tchat-message img {
    max-width: 90%;
    max-height: 150px;
}
.lcdd-tchat-message img.emoji {
    width: 24px;
    height: 24px;
}
.lcdd-tchat-errors .alert ul {
    margin-bottom: 0;
}
.lcdd-tchat-errors .alert-dismissible .close {
    padding: 0.1rem 0.6rem;
}
</style>
